module.exports = __webpack_public_path__ + "static/nodle-7cd40ba4944b3c08109d45992ac25337.jpg";